import { render } from "./SidebarComponent.vue?vue&type=template&id=5c75a3b9&scoped=true"
import script from "./SidebarComponent.vue?vue&type=script&lang=js"
export * from "./SidebarComponent.vue?vue&type=script&lang=js"

import "./SidebarComponent.vue?vue&type=style&index=0&id=5c75a3b9&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c75a3b9"]])

export default __exports__